export default function formatMileage(value, unit = "km", placeholder = "-", useKFormat = false) {
  if (value === null || value === undefined || value === "") {
    return placeholder;
  }

  let formattedValue;

  if (useKFormat && Number(value) >= 1000) {
    // Convert to 'k' format, e.g., 10300 => 10.3k
    const inThousands = Number(value) / 1000;

    // Round to one decimal if necessary (avoid .0)
    formattedValue = inThousands % 1 === 0 ? `${inThousands.toFixed(0)}k` : `${inThousands.toFixed(1)}k`;
  } else {
    // Default formatting with commas
    formattedValue = Number(value).toLocaleString();
  }

  return `${formattedValue} ${unit}`;
}